import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { M_Table, NavigateContext, LoadingContext } from 'src/M_Components'

export const TransportClausesList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const openCrud = (operation, row) => {
        let label = t(`${operation}TransportClause`)
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            if (!row) {
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }
            label = `${t(`${operation}TransportClause`)} - ${row.ClauseCode}`
            ctx.setPassValues({ Operation: operation, Row: row })
        } else {
            ctx.setPassValues({ Operation: operation })
        }
        
        ctx2.newTab('go/transportClausesCrud', label)
    }

    return (
        <M_Table
            entityName={'transportClause'}
            roleName={'transportClauses'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'TransportClauses'}
            removeContextItems={['Print']}
            replaceFunctions={new Map([
                ['Create', () => openCrud('Create')],
                ['Edit', (row) => openCrud('Edit', row)],
                ['Copy', (row) => openCrud('Copy', row)],
                ['View', (row) => openCrud('View', row)]
            ])}
        />
    )
}
